(() => {
  const selector = 'select:not([multiple]):not([size])';

  class FormeSelect {
    constructor(select) {
      this.select = select;
      this.select.dataset.formeSelectReady = 'true';
      this.wrapper = document.createElement('div');
      this.wrapper.className = 'forme-select';
      if (select.closest('.header-search__field')) this.wrapper.classList.add('forme-select--header-search');
      if (select.closest('.topbar__localization')) this.wrapper.classList.add('forme-select--topbar');
      if (select.closest('.fh-country')) this.wrapper.classList.add('forme-select--footer');
      if (select.closest('.collection-products__select-wrap')) this.wrapper.classList.add('forme-select--sort');
      if (select.closest('dialog')) this.wrapper.classList.add('forme-select--dialog');

      select.parentNode.insertBefore(this.wrapper, select);
      this.wrapper.appendChild(select);
      select.classList.add('forme-select__native');

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'forme-select__button';
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.innerHTML = '<span class="forme-select__value"></span><svg viewBox="0 0 12 12" aria-hidden="true"><path d="m2.5 4.5 3.5 3 3.5-3"/></svg>';

      this.menu = document.createElement('div');
      this.menu.className = 'forme-select__menu';
      this.menu.setAttribute('role', 'listbox');
      this.menu.hidden = true;
      this.wrapper.append(this.button, this.menu);

      this.button.addEventListener('click', () => this.toggle());
      this.button.addEventListener('keydown', event => this.onButtonKeydown(event));
      this.select.addEventListener('change', () => this.sync());
      this.render();
    }

    render() {
      this.menu.replaceChildren();
      [...this.select.options].forEach((option, index) => {
        const label = option.textContent.trim();
        if (!label) return;
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'forme-select__option';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(index === this.select.selectedIndex));
        item.disabled = option.disabled;
        item.dataset.index = String(index);
        item.textContent = label;
        item.addEventListener('click', () => this.choose(index));
        item.addEventListener('keydown', event => this.onOptionKeydown(event));
        this.menu.appendChild(item);
      });
      this.sync();
    }

    sync() {
      const selected = this.select.options[this.select.selectedIndex];
      this.button.querySelector('.forme-select__value').textContent = selected?.textContent.trim() || '';
      [...this.menu.children].forEach(item => item.setAttribute('aria-selected', String(Number(item.dataset.index) === this.select.selectedIndex)));
      this.button.disabled = this.select.disabled;
    }

    open() {
      document.querySelectorAll('.forme-select.is-open').forEach(node => {
        if (node !== this.wrapper) node._formeSelect?.close();
      });
      this.menu.hidden = false;
      this.wrapper.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
    }

    close(focusButton = false) {
      this.menu.hidden = true;
      this.wrapper.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      if (focusButton) this.button.focus();
    }

    toggle() { this.wrapper.classList.contains('is-open') ? this.close() : this.open(); }

    choose(index) {
      if (this.select.selectedIndex !== index) {
        this.select.selectedIndex = index;
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.sync();
      this.close(true);
    }

    focusOption(index) {
      const options = [...this.menu.querySelectorAll('.forme-select__option:not(:disabled)')];
      if (!options.length) return;
      const current = options.findIndex(item => Number(item.dataset.index) === index);
      options[Math.max(0, current)].focus();
    }

    onButtonKeydown(event) {
      if (!['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      this.open();
      const enabled = [...this.menu.querySelectorAll('.forme-select__option:not(:disabled)')];
      const selected = enabled.find(item => Number(item.dataset.index) === this.select.selectedIndex);
      (selected || enabled[0])?.focus();
    }

    onOptionKeydown(event) {
      const items = [...this.menu.querySelectorAll('.forme-select__option:not(:disabled)')];
      const current = items.indexOf(event.currentTarget);
      if (event.key === 'Escape' || event.key === 'Tab') return this.close(event.key === 'Escape');
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        return this.choose(Number(event.currentTarget.dataset.index));
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : current + (event.key === 'ArrowDown' ? 1 : -1);
      next = (next + items.length) % items.length;
      items[next]?.focus();
    }
  }

  const enhance = root => root.querySelectorAll?.(`${selector}:not([data-forme-select-ready])`).forEach(select => {
    const instance = new FormeSelect(select);
    instance.wrapper._formeSelect = instance;
  });

  const start = () => {
    enhance(document);
    document.addEventListener('click', event => {
      document.querySelectorAll('.forme-select.is-open').forEach(node => {
        if (!node.contains(event.target)) node._formeSelect?.close();
      });
    });
    document.addEventListener('shopify:section:load', event => enhance(event.target));
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches?.(selector) && !node.dataset.formeSelectReady) enhance(node.parentElement);
      else enhance(node);
    }))).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
